import { CLICK_IMPRESSION_REPORTING_METHODS, TRACKING_LINK_CATEGORIES, TRANSLATE_PREFIX } from '../../consts';

const TRACKING_LINK_OPTIONS_TAB_ID = 'tracking_link_options';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const { SERVER_SIDE, BOTH } = CLICK_IMPRESSION_REPORTING_METHODS;

/** Reporting methods that use server-side tracking-link rules (required / recommended macros). */
export const SERVER_SIDE_METHODS = [SERVER_SIDE, BOTH];

export const FILTER_BUTTONS = [
    { key: TRACKING_LINK_CATEGORIES.ALL, labelKey: `${TAB_PREFIX}.FILTER_ALL` },
    { key: TRACKING_LINK_CATEGORIES.DEVICE_LEVEL, labelKey: `${TAB_PREFIX}.FILTER_DEVICE_LEVEL` },
    { key: TRACKING_LINK_CATEGORIES.CAMPAIGN, labelKey: `${TAB_PREFIX}.FILTER_CAMPAIGN` },
    { key: TRACKING_LINK_CATEGORIES.PUBLISHER, labelKey: `${TAB_PREFIX}.FILTER_PUBLISHER` },
    { key: TRACKING_LINK_CATEGORIES.OTHER, labelKey: `${TAB_PREFIX}.FILTER_OTHER` },
    { key: TRACKING_LINK_CATEGORIES.CUSTOM, labelKey: `${TAB_PREFIX}.FILTER_CUSTOM` },
];

export const FIELD_PATH = `formData.${TRACKING_LINK_OPTIONS_TAB_ID}.tracking_link_parameters`;
